import { SNAP_THRESHOLD_PCT } from "../constants";
import { SnapGuides } from "../types";

interface ApplyCenterSnapInput {
  newX: number;
  newY: number;
  widthPct: number;
  heightPct: number;
}

interface ApplyCenterSnapResult {
  x: number;
  y: number;
  guides: SnapGuides;
}

/**
 * Snap к горизонтальному/вертикальному центру: проверяет близость центра
 * overlay'а к 50% и притягивает top-left соответственно. Возвращает
 * скорректированные координаты и состояние snap-гайдов.
 */
export const applyCenterSnap = ({
  newX,
  newY,
  widthPct,
  heightPct,
}: ApplyCenterSnapInput): ApplyCenterSnapResult => {
  const centerXOffsetPct = widthPct / 2;
  const centerYOffsetPct = heightPct / 2;
  const overlayCenterX = newX + centerXOffsetPct;
  const overlayCenterY = newY + centerYOffsetPct;
  const vSnap = Math.abs(overlayCenterX - 50) < SNAP_THRESHOLD_PCT;
  const hSnap = Math.abs(overlayCenterY - 50) < SNAP_THRESHOLD_PCT;
  return {
    x: vSnap ? 50 - centerXOffsetPct : newX,
    y: hSnap ? 50 - centerYOffsetPct : newY,
    guides: { v: vSnap, h: hSnap },
  };
};
